export const FETCH_PROVEEDORES_REQUEST = "FETCH_PROVEEDORES_REQUEST";
export const FETCH_PROVEEDORES_SUCCESS = "FETCH_PROVEEDORES_SUCCESS";
export const FETCH_PROVEEDORES_FAILURE = "FETCH_PROVEEDORES_FAILURE";
